module.exports = __webpack_public_path__ + "assets/img/call-quality.bc9062e3.svg";